import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IncidentStatus } from '@models';

@Component({
  imports: [NgClass],
  selector: 'app-incident-status',
  styleUrls: ['./incident-status.component.scss'],
  template: `<span
    class="status-block"
    [ngClass]="{
      'status-in-progress': status === incidentStatus.IN_PROGRESS,
      'status-in-queue': status === incidentStatus.IN_QUEUE,
      'status-resolved': status === incidentStatus.RESOLVED
    }"
  >
    {{ statusText[status] }}
  </span>`,
})
export class IncidentStatusComponent {
  @Input() status!: IncidentStatus;
  statusText = {
    [IncidentStatus.IN_QUEUE]: 'In queue',
    [IncidentStatus.IN_PROGRESS]: 'In progress',
    [IncidentStatus.RESOLVED]: 'Resolved',
  };
  incidentStatus = IncidentStatus;
}
